import React, { useContext } from "react";
import RankingsNavContainer from "./Containers/RankingsNavContainer";
import RankingPanelContainer from "../Ranking/RankingPanelContainer";
import SubleaguesListPanelContainer from "../Subleagues/Containers/SubleaguesListPanelContainer";
import SubleaguePanelContainer from "../Subleagues/Containers/SubleaguePanelContainer";
import GamesMenuContainer from "../GamesMenu/GamesMenuContainer";
import LiveUpdateContainer from "../LiveUpdate/Panel/LiveUpdatePanelContainer";
import CurrentGameMenu from "./CurrentGameMenu.jsx";
import NewsPanelContainer from "../NewsFeed/NewsPanelContainer";
import AdminMenuContainer from "../AdminMenu/AdminMenuContainer";
import { IsMobileContext } from "../isMobileContext";

const RankingsPage = ({current, links, loading}) => {
    const ctx = useContext(IsMobileContext);

    return (
        <div className="my-results">
            { !ctx.isMobile ? (<div className="my-results__col-left">
                <CurrentGameMenu game={current} links={links}/>
                <GamesMenuContainer/>
                <AdminMenuContainer game={current}/>
            </div>) : null}
            <div className="my-results__col-middle">
                {loading
                    ? <div className="alert alert-info">Loading...</div> : null
                }
                <RankingPanelContainer/>
                <SubleaguePanelContainer/>
                <SubleaguesListPanelContainer/>
                <LiveUpdateContainer />
                {ctx.isMobile ? null : <NewsPanelContainer/>}
            </div>
            <div className="my-results__col-right">
                <RankingsNavContainer/>
                {!ctx.isMobile ? null : <NewsPanelContainer/>}
            </div>
            {
                ctx.isMobile ? <div className="my-results__col-right"><AdminMenuContainer game={current}/></div> : null
            }
        </div>
    );
};

export default RankingsPage